<template>
  <div class="wrapper">
    <page-header/>
    <div class="content container">
      <settings-checker>
        <feature-disabled v-if="!clientRegistrationEnabled"/>
        <template v-else>
          <div v-if="!addedRegistration" class="w-100">
            <error-banner v-if="error" :message="error"/>
            <client-details v-model="clientDetailsStatus"/>
            <new-pets v-model="clientPetsStatus"/>
            <vet-contact v-model="clientVetContactStatus"/>
            <alternate-contact v-model="clientAltContactStatus"/>
            <contract :site-id="siteId" v-model="signatureData" :validation-message="signatureMessage"/>
            <marketing-setting/>
            <div v-if="recaptchaEnabled" class="my-5">
              <turnstile-widget ref="turnstileWidget" execution="execute" action="form-submission" @verified="handleRecaptchaToken" @errored="handleRecaptchaError" @expired="clearRecaptcha" @timedOut="clearRecaptcha" @retrying="clearRecaptcha" @interactiveStart="pauseRecaptchaWait" @interactiveEnd="resumeRecaptchaWait"/>
              <validation-message v-if="recaptchaMessage" :message="recaptchaMessage"/>
            </div>
            <div class="d-flex flex-column align-items-center">
              <button class="btn btn-secondary" @click="handleSubmit" v-bind:disabled="addingClientRegistration || pendingRecaptcha">
                Submit
                <span v-if="addingClientRegistration || pendingRecaptcha" class="inline-loader"></span>
              </button>
            </div>
          </div>
          <div v-else class="d-flex flex-column align-items-center justify-content-center">
            <img class="col-md-8" src="@/assets/Images/welcome-to-our-pack.png" alt="Welcome">
            <button @click="handleAnotherRegistration" class="btn btn-secondary mt-5">
              Submit Another Registration
            </button>
          </div>
        </template>
      </settings-checker>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { ClientRegistrationAddMixin } from '@/mixins/GeneralRegistration/ClientRegistrationAddMixin'
import { SiteGeneralRegistrationSettingMixin } from '@/mixins/GeneralRegistration/SiteGeneralRegistrationSettingMixin'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import ClientDetailsSection from './ClientDetails/ClientDetailsSection.vue'
import NewPets from './Pets/NewPets.vue'
import VetContact from './VetContact.vue'
import AlternateContact from './AlternateContact.vue'
import MarketingSetting from './MarketingSetting.vue'
import SettingsChecker from './SettingsChecker.vue'
import FeatureDisabled from './FeatureDisabled.vue'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'
import PageHeader from './Layout/PageHeader.vue'
import PageFooter from './Layout/PageFooter.vue'
import ValidationMessage from '../ErrorValidation/ValidationMessage.vue'
import TurnstileWidget from '../Booking/TurnstileWidget.vue'
import Contract from './Contract/Contract.vue'

export default {
  name: 'ClientRegistration',
  mixins: [ClientRegistrationAddMixin, SiteGeneralRegistrationSettingMixin, StatusEmitterMixin],
  data () {
    return {
      addedRegistration: null,
      clientDetailsStatus: {},
      clientAltContactStatus: {},
      clientVetContactStatus: {},
      clientPetsStatus: {}
    }
  },
  computed: {
    clientRegistrationId () {
      return this.addedRegistration?.id || ''
    },
    siteId () {
      return this.$route.params.siteId || this.$route.query.siteId || ''
    },
    clientRegistrationEnabled () {
      return this.settingObject?.clientRegistrationEnabled || false
    },
    statuses () {
      return [
        this.clientDetailsStatus,
        this.clientAltContactStatus,
        this.clientVetContactStatus,
        this.clientPetsStatus
      ]
    },
    validated () {
      return this.statuses.every(s => !!s.validated)
    }
  },
  methods: {
    ...mapMutations('ApplicationEvents', [
      'triggerSaveClientRegistration'
    ]),
    handleSubmit () {
      // validate all sections first; submit only after the status emits settle
      this.triggerSaveClientRegistration()
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.validated) {
            this.tryAddClientRegistration()
          }
        })
      })
    },
    handleAnotherRegistration () {
      window.location.reload()
    },
    afterClientRegistrationAdded (value) {
      this.addedRegistration = value
    }
  },
  components: {
    'page-header': PageHeader,
    'page-footer': PageFooter,
    'client-details': ClientDetailsSection,
    'new-pets': NewPets,
    'vet-contact': VetContact,
    'alternate-contact': AlternateContact,
    'marketing-setting': MarketingSetting,
    'settings-checker': SettingsChecker,
    'feature-disabled': FeatureDisabled,
    'error-banner': ErrorBanner,
    'validation-message': ValidationMessage,
    'turnstile-widget': TurnstileWidget,
    contract: Contract
  }
}
</script>
